import styled from 'styled-components';
import { color } from '../../../resources';

export const StyledContainer = styled.div`
  background-color: ${color.white};
  padding: 16px;
`;

// ทาสีแถวที่ใช้ได้จริงติดลบ ใช้ !important เพราะต้องชนะ zebra stripe ของ TableComponent
export const StyledStockTable = styled.div`
  .stock-claim-row-danger > td {
    background-color: #fff1f0 !important;
  }
  .stock-claim-row-danger:hover > td {
    background-color: #ffd8d3 !important;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
`;

export const SummaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
`;

export const SummaryCard = styled.div`
  flex: 1;
  min-width: 200px;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: #fafafa;
  border: 1px solid #f0f0f0;
`;
